export const FIELDS = {
  NOTE: 'dispatchNote',
  APARTMENT: 'apartmentDetails',
  TEXT_ADDRESS: 'textAddress'
};

export const STREET_NUMBER = 'street_number';
